import { BranchesRouters } from "../Branches/routers"
import { DashboardRouters } from "../Dashboard/routers"
import { POSRouters } from "../POS/routers"
import { ProductsRouters } from "../Products/routers"
import { ClientsRouters } from "../Clients/routers"
import { SalesPersonRouters } from "../../Seller/routers"
import { StocksRouters } from "../Stocks/routers"
import { FinancialRouters } from "../Financial/routers"
import { NFeRouters } from "../../Fiscal/NFe/routers"
import { NFCeRouters } from "../../Fiscal/NFCe/routers"
import { NFSERouters } from "../../Fiscal/NFSe/routers"
import { DigitalCertificateRouters } from "../DigitalCertificate/routers"
import { SettingsRouters } from "../Settings/routers"
import { HelpRouters } from "../Help/routers"
import { SalesRouters } from "../Sales/routers"
import { CTERouters } from "../../Fiscal/CTE/routers"
import {BarcodesRouters} from "../Barcodes/routers"
import { PurchasesRouters } from "../Purchases/routers"

export default [
  { ...BranchesRouters, fiscal: false },
  { ...DashboardRouters, fiscal: false },
  { ...DigitalCertificateRouters, fiscal: true },
  { ...ProductsRouters, fiscal: false },
  { ...ClientsRouters, fiscal: false },
  { ...NFeRouters, fiscal: true },
  { ...POSRouters, fiscal: false },
  { ...NFCeRouters, fiscal: true },
  { ...CTERouters, fiscal: true },
  { ...NFSERouters, fiscal: true },
  { ...FinancialRouters, fiscal: false },
  { ...BarcodesRouters, fiscal: false},
  { ...SalesRouters, fiscal: false },
  


  /// COMPRAS
  // {...PurchasesRouters, fiscal: false},
  /// END COMPRAS
  

  { ...StocksRouters, fiscal: false },
  { ...SalesPersonRouters, fiscal: false },
  { ...SettingsRouters, fiscal: false },
  { ...HelpRouters, fiscal: false },
  
]



// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/menu.js